<template>
  <AppModal
    v-model="value"
    :header-name="$t('Edit profile') /*ToDo check last update*/"
    :footer-hide="false"
    @click:submit="handleUpdate"
    @click:cancel="triggerCancel"
    :width="900"
    :loading="loading"
    class="edit-profile"
  >
    <Form
      ref="infoForm"
      class="profile-form"
      :model="info"
      label-position="left"
      :label-width="120"
      :rules="infoRules"
      style="margin: 10px 0 0 10px"
    >
      <div class="full-height">
        <Row type="flex" :gutter="10" style="margin-bottom: 15px">
          <i-col :xs="24" :sm="24" :md="8" :lg="8" class="profile-avatar-col">
            <Card
              class="profile-avatar cards edit-profile-cards"
              align="center"
            >
              <Upload
                id="profilePic"
                type="drag"
                action=""
                :before-upload="beforeDocumentUpload"
              >
                <div class="edit-profile-image circular-image">
                  <img v-if="currentAvatar" :src="currentAvatar" />
                  <Icon v-else type="ios-person" size="180" />
                </div>
                <p style="padding-top: 50px">
                  {{ $t("Upload profile picture") }}
                </p>
                <p>
                  {{ $t("(Click edit image or drag a picture to upload)") }}
                </p>
                <div style="position: relative; padding-top: 25px">
                  <Button class="confirm-button" style="width: 150px">
                    {{ $t("Edit image") }}
                  </Button>
                </div>
              </Upload>
              <Button
                v-if="info.avatar"
                class="little-button little-button-red"
                @click="removeAvatar()"
                style="width: 150px"
              >
                {{ $t("Delete picture") }}
                <Icon type="md-trash" />
              </Button>
            </Card>
          </i-col>
          <i-col :xs="24" :sm="24" :md="16" :lg="16">
            <Card class="cards edit-profile-cards">
              <FormItem
                :label="$t('First name: ')"
                prop="first_name"
                :error="infoErrors.first_name"
              >
                <Input v-model="info.first_name" style="width: 100%" />
              </FormItem>
              <FormItem
                :label="$t('Last name: ')"
                prop="last_name"
                :error="infoErrors.last_name"
              >
                <Input v-model="info.last_name" style="width: 100%" />
              </FormItem>
              <FormItem
                :label="$t('Cellphone: ')"
                prop="cellphone"
                :error="infoErrors.cellphone"
              >
                <AppPhoneInput
                  ref="form-cellphone"
                  v-model="info.cellphone"
                  style="width: 100%"
                />
              </FormItem>
            </Card>
          </i-col>
        </Row>
      </div>
    </Form>
  </AppModal>
</template>

<script>
import AppModal from "@/components/common/AppModal";
import { patchAccount } from "@/services/auth.service";
import AppPhoneInput from "@/components/common/AppPhoneInput";
import { mapActions } from "vuex";
import { updateAuthSessionByKeys } from "@/helpers/auth.helper";
import { FORM_RULE_REQUIRED_FIELD } from "@/helpers/common.helper";

export default {
  name: "EditProfile",
  components: {
    AppModal,
    AppPhoneInput,
  },
  props: {
    value: Boolean,
  },
  data() {
    const checkContact = (rule, value, callback) => {
      let str = "form-".concat(rule.fullField);
      if (value === "") {
        callback();
      } else if (!this.$refs[str].validate()) {
        callback(new Error(this.$t("Invalid format")));
      } else callback();
    };
    return {
      info: {
        cellphone: "",
        first_name: "",
        last_name: "",
      },
      loading: false,
      updated: null,
      avatarFileForUpload: null, // Onl yset if a new avatar is setup for upload
      avatarBlob: null, // Loaded version of avatarFileForUpload, for temporary display
      infoRules: {
        cellphone: [{ validator: checkContact, trigger: "blur" }],
        first_name: [FORM_RULE_REQUIRED_FIELD],
        last_name: [FORM_RULE_REQUIRED_FIELD],
      },
      infoErrors: {
        cellphone: "",
        first_name: "",
        last_name: "",
      },
    };
  },
  computed: {
    lastUpdate() {
      return this.updated;
    },
    currentAvatar() {
      if (this.avatarBlob) {
        return this.avatarBlob;
      } else {
        return this.info.avatar;
      }
    },
  },
  methods: {
    ...mapActions({ setUserProfile: "userDetail/setUserProfile" }),

    cancel() {
      this.$emit("input", false);
    },
    setFormData(data, update) {
      this.avatarFileForUpload = null;
      this.avatarBlob = null;
      this.info = { ...data };
      this.updated = update;
    },
    beforeDocumentUpload(avatar) {
      this.avatarFileForUpload = avatar;

      let reader = new FileReader();
      reader.readAsDataURL(avatar);
      reader.onload = () => {
        this.avatarBlob = reader.result;
      };

      return false;
    },

    handleUpdate() {
      const self = this;

      self.$refs["infoForm"].validate((valid) => {
        if (valid) {
          
          let infoFormData = {
            first_name: this.info.first_name,
            last_name: this.info.last_name,
            cellphone: this.info.cellphone,
          };
          if (this.avatarFileForUpload)
            infoFormData.avatar = this.avatarFileForUpload; // "File" object

          self.loading = true;
          patchAccount(infoFormData)
            .then((res) => {
              this.$Message.success(
                this.$t("Successfully updated your profile")
              );
              let data = { ...res.data };
              this.$emit("infoUpdated", data);
              //this.setUserProfile(res.data);
              //updateAuthSessionByKeys(res.data);
              self.loading = false;
              self.triggerCancel();
            })
            .catch((err) => {
              self.loading = false;
              const error = err.response;
              if (error.status === 400) {
                self.resetDataName(self, "infoErrors");
                for (let col in error.data) {
                  self.infoErrors[col] = error.data[col][0];
                }
              } else {
                self.$Message.error({
                  content: this.$t(
                    "There was an error while updating your profile"
                  ),
                  duration: 5,
                });
              }
            });
        } else {
          self.$Message.error({
            content: this.$t("Please review required fields before submitting"),
            duration: 5,
          });
        }
      });
    },
    triggerCancel() {
      this.$refs["infoForm"].resetFields();
      this.$emit("input", false);
    },
    removeAvatar() {
      console.log("remove");
      let infoFormData = { avatar: "" };
      this.imageLoading = true;

      patchAccount(infoFormData)
        .then((res) => {
          this.info.avatar = res.data.avatar;
          this.$Message.success(
            this.$t("Successfully deleted your profile image")
          );
          console.log(res);
          this.imageLoading = false;
        })
        .catch((err) => {
          this.imageLoading = false;
          this.$Message.error({
            // No need to detail, here
            content: this.$t(
              "There was an error while deleting your profile image"
            ),
            duration: 5,
          });
        });
    },
  },
};
</script>

<style>
.profile-form p {
  font-size: 10px;
}
.edit-profile .ivu-modal-body {
  padding-top: 5px;
}
.edit-profile-cards {
  padding: 0px 15px 0px 5px;
  height: 100%;
}

.profile-form .profile-avatar .ivu-card-body {
  height: 100%;
  padding: 0;
}

.profile-form .cards {
  background: white;
  box-shadow: none;
  border: 1px solid lightgray;
}

.cards.edit-profile-cards.ivu-card.ivu-card-bordered {
  margin-bottom: 0;
  margin-right: 0;
}
</style>
